export default __webpack_public_path__ + "static/media/LynkcoType-Regular.55ab7a1e.ttf";